import { Shield, Users, Key } from "lucide-react";

const TIER_META = {
  client: {
    label: "CLIENT",
    cls: "bg-emerald-500 text-white border-emerald-600",
    Icon: Shield,
    title: "Represented by your agency",
  },
  network: {
    label: "NETWORK",
    cls: "bg-white text-blue-700 border-blue-400",
    Icon: Users,
    title: "Network player — available for introduction",
  },
  mandated: {
    label: "MANDATE",
    cls: "bg-amber-500 text-white border-amber-600",
    Icon: Key,
    title: "Mandated — collaboration with partner agency",
  },
};

export default function TierBadge({ tier = "client", size = "sm", showIcon = false }) {
  const meta = TIER_META[tier] || TIER_META.client;
  const Icon = meta.Icon;
  const dim = size === "lg" ? "text-[11px] px-2 py-0.5" : "text-[9px] px-1.5 py-0.5";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md font-black tracking-wider border ${meta.cls} ${dim}`}
      data-testid={`tier-badge-${tier}`}
      title={meta.title}
    >
      {showIcon && <Icon size={size === "lg" ? 10 : 8} strokeWidth={2.5} />}
      {meta.label}
    </span>
  );
}

export { TIER_META };
